var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 39.16C4.32 37.36 1 32.81 1 27.5C1 21.45 5.3 16.4 11.01 15.25C11 15.17 11 15.08 11 15C11 7.27 17.27 1 25 1C30.67 1 35.55 4.37 37.75 9.22C39.0238 8.42184 40.4968 7.99899 42 8C46.25 8 49.72 11.31 49.98 15.49C55.19 17 59 21.81 59 27.5C59 32.81 55.68 37.36 51 39.16H9Z",
    fill: "#4B84DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99905 38V24C8.99905 23.2044 9.31512 22.4413 9.87773 21.8787C10.4403 21.3161 11.2034 21 11.999 21H22.756C23.552 21 24.315 21.316 24.877 21.879L26.1201 23.122C26.6825 23.6846 27.4455 24.0008 28.241 24.001H47.9981C48.7937 24.001 49.5568 24.3171 50.1194 24.8797C50.682 25.4423 50.9981 26.2053 50.9981 27.001V35.001L8.99805 38.001L8.99905 38Z",
    fill: "#69ADFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 37V29C13 28.7348 13.1054 28.4804 13.2929 28.2929C13.4804 28.1054 13.7348 28 14 28H46C46.2652 28 46.5196 28.1054 46.7071 28.2929C46.8946 28.4804 47 28.7348 47 29V37H13Z",
    fill: "#E8ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56V35C51 34.2044 50.6839 33.4413 50.1213 32.8787C49.5587 32.3161 48.7957 32 48 32H37.243C36.447 32 35.684 32.316 35.122 32.879L33.879 34.122C33.3165 34.6846 32.5536 35.0008 31.758 35.001H12C11.2044 35.001 10.4413 35.3171 9.87868 35.8797C9.31607 36.4423 9 37.2053 9 38.001V56.001C9 56.7966 9.31607 57.5597 9.87868 58.1223C10.4413 58.6849 11.2044 59.001 12 59.001H48C48.7957 59.001 49.5587 58.6849 50.1213 58.1223C50.6839 57.5597 51 56.7956 51 56Z",
    fill: "#8DD1FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.3502da7d0c7e0032188a14c5bd35a096.svg";
export { ForwardRef as ReactComponent };